export const ModalCypressAttribute = {
  modals: {
    CONFIRM_MODAL: 'ModalCypressAttribute:modals:CONFIRM_MODAL',
    DELETE_MODAL: 'ModalCypressAttribute:DELETE_MODAL',
    UNSAVED_DATA_WARNING_MODAL: 'ModalCypressAttribute:UNSAVED_DATA_WARNING_MODAL',
    CONFLICT_WARNING_MODAL: 'ModalCypressAttribute:CONFLICT_WARNING_MODAL'
  },
  views: {
    TITLE: 'ModalCypressAttribute:views:TITLE',
    FOOTER_CONTAINER: 'ModalCypressAttribute:views:FOOTER_CONTAINER'
  },
  buttons: {
    CLOSE: 'ModalCypressAttribute:CLOSE',
    CLOSE_IN_MODAL: 'ModalCypressAttribute:CLOSE_IN_MODAL',
    CONFIRM: 'ModalCypressAttribute:CONFIRM',
    CANCEL: 'ModalCypressAttribute:CANCEL',
    DOWNLOAD: 'ModalCypressAttribute:DOWNLOAD',
    EXIT: 'ModalCypressAttribute:EXIT',
    RIGHT_BUTTON: 'ModalCypressAttribute:RIGHT_BUTTON',
    ACTION: 'ModalCypressAttribute:ACTION'
  },
  preview_pdf: {
    buttons: {},
    inputs: {},
    views: {
      IFRAME: 'ModalCypressAttribute:preview_pdf:views:IFRAME',
      PDF_VIEWER: 'pdf-viewer#viewer'
    }
  },
  edit_pdf: {
    buttons: {
      ZOOM_IN: 'ModalCypressAttribute:edit_pdf:buttons:ZOOM_IN',
      ZOOM_OUT: 'ModalCypressAttribute:edit_pdf:buttons:ZOOM_OUT'
    }
  }
};
